export * from './TooltipDeprecated';
